if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			if (this.requestController || this.classList.contains('product-recommendations--loaded') || !this.dataset.url) return;
			const controller = new AbortController();
			this.requestController = controller;
			return fetch(this.dataset.url, { signal: controller.signal })
				.then(response => {
					if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
					return response.text();
				})
				.then(text => {
					if (!this.isConnected || this.requestController !== controller) return;
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						if (window.lazySizes && window.lazySizes.loader) {
							this.querySelectorAll('.lazyload').forEach((image) => {
								window.lazySizes.loader.unveil(image);
							});
						}
					}

					this.classList.add('product-recommendations--loaded');

				})
				.catch(e => {
					if (e.name !== 'AbortError') console.error(e);
				})
				.finally(() => {
					if (this.requestController === controller) this.requestController = null;
				});
		}
		connectedCallback() {
			if (this.classList.contains('product-recommendations--loaded') || this.observer || this.requestController) return;
			if (this.dataset.defer !== 'true' || this.cart || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
				this.fetchProducts();
				return;
			}
			// The empty custom element is display:none; observe its section's position.
			const target = this.closest('.shopify-section');
			if (!target) {
				this.fetchProducts();
				return;
			}
			this.observer = new IntersectionObserver(entries => {
				if (!entries.some(entry => entry.isIntersecting)) return;
				this.observer?.disconnect();
				this.observer = null;
				this.fetchProducts();
			}, { rootMargin: '600px 0px' });
			this.observer.observe(target);
		}
		disconnectedCallback() {
			this.observer?.disconnect();
			this.observer = null;
			this.requestController?.abort();
			this.requestController = null;
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
